import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { cssVar, mediaQuery } from 'src/app/styles/helper';
import styled, { css, keyframes } from 'styled-components';
import { hexToRgba } from 'styles/colors';

export const LogosContainer = styled(Stack)`
  height: 48px;
  width: 100%;
`;

const autoScroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const autoScrollReverse = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(50%);
  }
`;

interface LogosRailProps {
  $reverse?: boolean;
  $duration?: number;
}

export const LogosRail = styled.div<LogosRailProps>`
  height: 100%;
  width: fit-content;
  position: absolute;
  display: flex;
  top: 0;

  z-index: 1;

  ${({ $reverse, $duration }) =>
    $reverse
      ? css`
          right: 0;
          animation: ${autoScrollReverse} ${$duration}s linear infinite;
        `
      : css`
          left: 0;
          animation: ${autoScroll} ${$duration}s linear infinite;
        `}

  .logo {
    margin-right: ${cssVar('spacing-6xl')};
  }

  ${mediaQuery(
    'sm',
    css`
      .logo {
        margin-right: ${cssVar('spacing-7xl')};
      }
    `
  )}
`;

interface GradientProps {
  theme: 'default' | 'brand';
  customGradientColor?: string;
}

const gradientStyles = css<GradientProps>`
  ${({ theme }) =>
    theme === 'brand'
      ? ''
      : css`
          filter: invert(1);
        `}

  background: linear-gradient(
    90deg,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0)} 0%,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0.01)} 8.07%,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0.02)} 15.54%,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0.05)} 22.5%,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0.08)} 29.04%,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0.13)} 35.26%,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0.18)} 41.25%,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0.25)} 47.1%,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0.32)} 52.9%,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0.4)} 58.75%,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0.48)} 64.74%,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0.58)} 70.96%,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0.67)} 77.5%,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0.78)} 84.46%,
    ${({ customGradientColor }) => hexToRgba(customGradientColor, 0.89)} 91.93%,
    ${({ customGradientColor }) => customGradientColor} 100%
  );
  position: absolute;
  top: 0;
  width: 200px;
  height: 100%;
  z-index: 2;

  ${mediaQuery(
    'sm',
    css`
      width: 80px;
    `
  )}
`;

export const GradientLeft = styled.div<GradientProps>`
  left: 0;
  transform: rotate(180deg);

  ${gradientStyles}
`;

export const GradientRight = styled.div<GradientProps>`
  right: 0;
  ${gradientStyles}
`;
